export default "__VITE_ASSET__eccc5226__"